import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { IToolCall } from '../../../models/tool-call.model';
import { getToolTitle } from '../../../utils/utils';
import { TOOLS } from '../../../constants/tool.constants';

interface SearchResult {
    title: string;
    url: string;
    content: string;
}

interface ResultType {
    icon: string;
    label: string;
}

@Component({
    selector: 'app-web-search-tool-view',
    standalone: true,
    imports: [
        CommonModule,
        BadgeModule,
        TooltipModule,
        IconComponent
    ],
    templateUrl: './web-search-tool-view.component.html',
    styleUrl: './web-search-tool-view.component.scss'
})
export class WebSearchToolViewComponent {
    //#region Inputs
    toolCall = input<Partial<IToolCall>>({});
    //#endregion

    //#region Computed values
    toolTitle = computed(() => getToolTitle(this.toolCall()?.name as TOOLS));
    parsedToolContent = computed(() => {
        try {
            return JSON.parse(this.toolCall()?.toolContent || '{}');
        } catch {
            return {};
        }
    });
    //#endregion

    cleanUrl(url: string): string {
        try {
            const urlObj = new URL(url);
            return (
                urlObj.hostname.replace('www.', '') +
                (urlObj.pathname !== '/' ? urlObj.pathname : '')
            );
        } catch (e) {
            return url;
        }
    }

    getFavicon(url: string): string | null {
        try {
            const domain = new URL(url).hostname;
            return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
        } catch (e) {
            return null;
        }
    }

    getResultType(result: SearchResult): ResultType {
        const { url, title } = result;

        if (url.includes('news') || url.includes('article') || title.includes('News')) {
            return { icon: 'file-text', label: 'Article' };
        } else if (url.includes('wiki')) {
            return { icon: 'book-open', label: 'Wiki' };
        } else if (url.includes('blog')) {
            return { icon: 'calendar-days', label: 'Blog' };
        } else {
            return { icon: 'globe', label: 'Website' };
        }
    }

    openUrl(url: string): void {
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    onFaviconError(event: Event): void {
        const target = event.target as HTMLImageElement;
        if (target) {
            target.style.display = 'none';
        }
    }
}
